<i18n>
{
	"en": {
		"InputInfoToSearch": "Input info to search..."
	},
	"vi": {
		"InputInfoToSearch": "Nhập thông tin để tìm kiếm..."
	}
}
</i18n>

<template>
	<div class="cbs-relation-control-filter">
		<legend class="uppercase-first-letter text-solid-gray-1">{{ localValue.title }}</legend>
		<v-select
			multiple
			label="content"
			v-bind="$attrs"
			v-model="localValue.value"
			class="select-multiple w-full"
			:filterable="false"
			:close-on-select="false"
			:options="relationOptions"
			:key="`${localValue.title}-${localValue.id}`"
			:placeholder="`${$t('Actions.Choose')} ${localValue.title.toLowerCase()}`"
			@search="autoCompleteSelectRelation"
		>
			<span slot="no-options">{{ $t(`${!isSearching && searchText ? 'Notify.NoMatchingOptions' : 'InputInfoToSearch'}`) }}</span>
		</v-select>
	</div>
</template>

<script>
import requestV2GQL from "@/http/requests/request/request_v2_gql.js";

import vSelect from "vue-select";

export default {
	inheritAttrs: false,
	name: "RelationControlFilter",
	components: {
		vSelect
	},
    props: {
		value: {
			type: Object,
			required: true,
			validator: prop =>
				prop.hasOwnProperty("id") &&
				prop.hasOwnProperty("value") &&
				prop.hasOwnProperty("title") &&
				prop.hasOwnProperty("control") &&
				prop.hasOwnProperty("attributes")
		}
	},
	data() {
		return {
			searchText: null,
			isSearching: false,
			relationOptions: []
		};
	},
    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            }
		},
		localAttributesValue() {
			const attributesValue = typeof this.localValue.attributes === "string" ? JSON.parse(this.localValue.attributes) : this.localValue.attributes;
			return attributesValue;
		},
		localRelatedModelAttributeValue() {
			return this.localAttributesValue.related_model || "";
		}
	},
	methods: {
		autoCompleteSelectRelation(text, loading) {
			clearTimeout(this.timer);
			this.timer = setTimeout(async () => {
				try {
                    if (loading) {
                        loading(true);
					}
					this.isSearching = true;
					this.searchText = text || "";
					const model = this.localRelatedModelAttributeValue;
					const response = await requestV2GQL.getRelationByModel({
						model,
						page: 1,
						limit: 100,
						name: this.searchText
					});
					this.relationOptions = response;
				} catch (error) {
                    this.$helper.notifyError({
                        error,
                        context: this
                    });
				} finally {
                    if (loading) {
                        loading(false);
					}
					this.isSearching = false;
                }
			}, 300);
        }
	}
}
</script>

<style>

</style>